import React from 'react';
import { Link } from 'react-router-dom';

const LEGAL_LINKS = [
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms of Service' },
  { to: '/disclaimer', label: 'Disclaimer' },
];

export const FooterBottom = ({ year }) => (
  <div className="border-t border-gray-800 pt-8 mt-8">
    <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
      <p className="text-gray-400">
        © {year} AssetWise Business Consultants. All rights reserved.
      </p>
      <div className="flex gap-6">
        {LEGAL_LINKS.map(({ to, label }) => (
          <Link key={to} to={to} className="hover:text-cyan-400 transition-colors">{label}</Link>
        ))}
      </div>
    </div>
  </div>
);

export default FooterBottom;
